import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogTitle, DialogContent, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { KbdKey } from './kbd-key';
import { useKeyboardShortcuts } from '../context/keyboard-shortcuts-context';
export const ShortcutsModal = ({ open, onClose }) => {
    const { shortcuts } = useKeyboardShortcuts();
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: 'xs', fullWidth: true, children: [_jsxs(DialogTitle, { component: 'div', sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    py: '0.875rem',
                    px: '1.25rem',
                    borderBottom: '1px solid',
                    borderColor: 'divider'
                }, children: [_jsx(Typography, { sx: { fontSize: '1rem', fontWeight: 700 }, children: "Keyboard shortcuts" }), _jsx(IconButton, { onClick: onClose, size: 'small', edge: 'end', "aria-label": 'Close', sx: { color: 'text.disabled' }, children: _jsx(CloseIcon, { fontSize: 'small' }) })] }), _jsx(DialogContent, { sx: { p: 0, '& kbd': { display: 'inline-block' } }, children: shortcuts.map((s, i) => (_jsxs(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: '1.25rem',
                        py: '0.6875rem',
                        borderBottom: i < shortcuts.length - 1 ? '1px solid' : 'none',
                        borderColor: 'border2'
                    }, children: [_jsx(Typography, { sx: { fontSize: '0.875rem', color: 'text.secondary' }, children: s.label }), _jsx(KbdKey, { children: s.key })] }, s.key))) })] }));
};
//# sourceMappingURL=shortcuts-modal.js.map